import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UpdateCommunityTextService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'updateCommunityText',
      method: 'put',
      request: (communityTag, id, body, callback, t) => ({
        url: apiRoutes.communityTexts(communityTag, id),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'editCommunityTextFailed'),
            onSuccessMessage: t('editCommunityTextSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateCommunityTextService;
